module.exports = __webpack_public_path__ + "static/media/default_clan_inky.4dfe52c7.png";